module.exports = __webpack_public_path__ + "img/art.89041f88.jpg";